import React, {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from '../../reducer/reducer'
import {Checkout, UserInfoData} from '../modules/api/auth'
import {USER_INFO, USER_VERIFIED} from '../../actions'
import PrivateRequest from '../modules/api/PrivateRequest'

const AuthHandle = () => {

  const dispatch = useDispatch()
  if (localStorage.getItem('token')) {
    UserInfoData().then( (res) => {
      console.log('Checkout auth handle req',res)
      dispatch(USER_VERIFIED(res.data.user_verified))
      console.log('user_verified at private route', res.user_verified)
      return  res.user_verified
    }).catch((err) => console.log('err user_verified', err))

    Checkout().then((res) => {
      console.log('first', res)
      PrivateRequest().get('auth/check').then((res) => {
        return PrivateRequest().get('auth/user').then((res) => {
          dispatch(USER_VERIFIED(res.data.user_verified))
          dispatch(USER_INFO(res.data.user))
          console.log('auth/trs/user info', res)
          return res
        })
      })
    }).catch((err) => {
      console.log('err user/auth/check', err)
      // localStorage.clear()
    })
  }


    return null
}


export {AuthHandle}
